<template>
  <b-card v-if="admin">
    <template #header>
      <div class="row justify-content-between">
        <div class="col-auto">
          <b-badge variant="success" class="mr-2 fs-6">{{
            labelHeader
          }}</b-badge>

          <strong>
            Campanhas destacadas
            <strong class="destaque">em amarelo</strong>, possuem o envio de
            grade automática caso não respondidas!
          </strong>
        </div>
        <div class="col-auto">
          <b-button
            variant="primary"
            @click="
              () => {
                this.getListCampanhasAdmin()
                this.validaDatas(this.list)
                this.getListCampanhasAdmin()
              }
            "
          >
            <b-spinner small v-if="show_overlay"></b-spinner>
            <BootstrapIcon v-else icon="arrow-clockwise" color="white" />
          </b-button>

          <b-button class="ml-2" variant="primary" @click="newItem"
            >Novo Cadastro</b-button
          >
        </div>
      </div>
    </template>
    <b-col class="col-md-12 col-sm-12 col-lg-12">
      <OverlayPanel
        v-if="fieldsFilter.length > 0"
        class="fix-campanha-filter"
        ref="filtroCampanha"
        :showCloseIcon="true"
        :dismissable="true"
        :style="widthFilter ? { width: widthFilter } : { width: '450px' }"
      >
        <FilterDefault
          :key="key"
          :table="table"
          :item="filter"
          :labelHeader="labelHeader"
          :fieldsInput="fieldsFilter"
        ></FilterDefault>
      </OverlayPanel>

      <ConfirmDialog>
        <template #message="slotProps">
          <div class="flex p-4">
            <i :class="slotProps.message.icon" style="font-size: 1.5rem"></i>
            <p class="pl-2">{{ slotProps.message.message }}</p>
          </div>
        </template>
      </ConfirmDialog>

      <div :key="key">
        <b-overlay :show="show_overlay" rounded="sm">
          <DataTable
            :rowClass="rowClass"
            :value="list"
            class="p-datatable-sm"
            responsiveLayout="scroll"
            selectionMode="single"
            dataKey="id"
            :paginator="true"
            :rows="10"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 25, 50]"
          >
            <Column header="Nome" field="nome" :sortable="true">
              <template #body="item">
                <div class="fw-bold">
                  {{ item.data.nome }}
                </div>
              </template>
            </Column>
            <Column
              header="Identificação"
              field="identificacao"
              :sortable="true"
            >
              <template #body="item">
                <div>
                  {{ item.data.identificacao }}
                </div>
              </template>
            </Column>
            <Column header="Data Ínicio" field="data_ini" :sortable="true">
              <template #body="item">
                <div>
                  {{
                    moment(item.data.data_ini, 'YYYY-MM-DD H:mm').format(
                      'DD/MM/YYYY H:mm',
                    )
                  }}
                </div>
              </template>
            </Column>
            <Column header="Data Fim" field="data_fim" :sortable="true">
              <template #body="item">
                <div>
                  {{
                    moment(item.data.data_fim, 'YYYY-MM-DD H:mm').format(
                      'DD/MM/YYYY H:mm',
                    )
                  }}
                </div>
              </template>
            </Column>
            <Column header="Tempo restante" field="">
              <template #body="item">
                <CountDown
                  :campanha="item.data"
                  :date="item.data.data_fim"
                  @onFinish="finalizaCampanha"
                />
              </template>
            </Column>
            <Column header="Status" field="status" :sortable="true">
              <template #body="item">
                <div class="ml-2">
                  {{ item.data.status }}
                </div>
              </template>
            </Column>
            <Column field="Ações" :style="{ width: '200px' }" :sortable="false">
              <template #body="item">
                <PrimeButton
                  title="Exportar Produtos"
                  class="p-button-rounded bg-info mr-1 px-2 py"
                  @click="downloadProdutos(item.data)"
                >
                  <BootstrapIcon icon="file-earmark-arrow-down" color="white" />
                </PrimeButton>
                <PrimeButton
                  :disabled="item.data.selfarma == 'N'"
                  title="Relacionar Farmácias"
                  class="p-button-rounded p-button-primary mr-1 px-2 py"
                  @click="associarFarmacias(item.data)"
                >
                  <BootstrapIcon icon="clipboard-plus" color="white" />
                </PrimeButton>
                <button
                  type="button"
                  class="icon-button mr-1"
                  @click="abreListaPedidos(item.data)"
                >
                  <span class="material-icons"
                    ><BootstrapIcon icon="cart" color="white"
                  /></span>
                  <span
                    class="icon-button__badge"
                    v-if="pedidosNaoEnviados[item.data.id]"
                    >{{ pedidosNaoEnviados[item.data.id]?.qtd_pedidos }}</span
                  >
                </button>
                <PrimeButton
                  title="Editar Campanha"
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-warning mr-1"
                  @click="updateItem(item.data)"
                />
                <PrimeButton
                  :key="key"
                  title="Excluir Campanha"
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger mt-1"
                  @click="deleteItem(item.data)"
                />
              </template>
            </Column>
            <!-- <template #expansion="item">
              <List
                :key="key"
                :cam_campanha_id="selectedCampanha.id"
                :campanha="item"
              ></List>
            </template> -->
          </DataTable>
        </b-overlay>
      </div>
    </b-col>
  </b-card>

  <b-card v-if="!admin">
    <template #header>
      <div class="row justify-content-between">
        <div class="col-auto">
          <b-badge variant="success" class="mr-2 fs-6">{{
            labelHeader
          }}</b-badge>

          <strong>
            Campanhas destacadas
            <strong class="destaque">em amarelo</strong>, possuem o envio de
            grade automática caso não respondidas!
          </strong>
        </div>
        <div class="col-auto">
          <b-button
            class="ml-2"
            @click="exibeHistoricoPedidos"
            variant="primary"
          >
            <BootstrapIcon icon="clock-history" color="white" />
            Histórico de Pedidos
          </b-button>
        </div>
      </div>
    </template>
    <b-col class="col-md-12 col-sm-12 col-lg-12">
      <div v-show="this.error" class="error-banner">
        Token inválido. Tente novamente ou contacte o suporte!
      </div>
      <div v-show="!this.error" :key="key">
        <b-overlay :show="show_overlay" rounded="sm">
          <DataTable
            :rowClass="rowClass"
            :value="list"
            class="p-datatable-sm"
            responsiveLayout="scroll"
            selectionMode="single"
            dataKey="id"
            :paginator="true"
            :rows="10"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 25, 50]"
          >
            <Column header="Nome" field="nome" :sortable="true">
              <template #body="item">
                <div class="fw-bold">
                  {{ item.data.nome }}
                </div>
              </template>
            </Column>
            <Column
              header="Identificação"
              field="identificacao"
              :sortable="true"
            >
              <template #body="item">
                <div>
                  {{ item.data.identificacao }}
                </div>
              </template>
            </Column>
            <Column header="Data Ínicio" field="data_ini" :sortable="true">
              <template #body="item">
                <div>
                  {{
                    moment(item.data.data_ini, 'YYYY-MM-DD H:mm').format(
                      'DD/MM/YYYY H:mm',
                    )
                  }}
                </div>
              </template>
            </Column>
            <Column header="Data Fim" field="data_fim" :sortable="true">
              <template #body="item">
                <div>
                  {{
                    moment(item.data.data_fim, 'YYYY-MM-DD H:mm').format(
                      'DD/MM/YYYY H:mm',
                    )
                  }}
                </div>
              </template>
            </Column>
            <Column header="Tempo restante" field="">
              <template #body="item">
                <CountDown
                  :key="key"
                  :campanha_id="item.data.id"
                  :date="item.data.data_fim"
                  @onFinish="finalizaCampanha"
                />
              </template>
            </Column>
            <Column header="Status" field="status" :sortable="true">
              <template #body="item">
                <div>
                  {{ item.data.status }}
                </div>
              </template>
            </Column>
            <Column field="Ações" :style="{ width: '200px' }" :sortable="false">
              <template #body="item">
                <!-- <PrimeButton
                  title="Exportar Produtos"
                  class="p-button-rounded p-button-info mr-2 px-2 py"
                  @click="downloadProdutos(item.data)"
                >
                  <BootstrapIcon icon="file-earmark-arrow-down" color="white" />
                </PrimeButton> -->
                <PrimeButton
                  title="Listar Pedidos Para Esta Campanha"
                  icon="pi pi-shopping-cart"
                  class="p-button-rounded p-button-success mr-2"
                  @click="abreListagemFarmacias(item.data)"
                />
              </template>
            </Column>
          </DataTable>
        </b-overlay>
      </div>
    </b-col>
  </b-card>
</template>

<script>
import { useRoute } from 'vue-router'

import qs from 'qs'
import moment from 'moment'
import { format } from 'v-money3'
import { utils, writeFileXLSX } from 'xlsx'
import ConfirmDialog from 'primevue/confirmdialog'
import { endOfMonth, startOfMonth } from 'date-fns'

import config from '@/functions/formatMoney'
import service from '@/services/BaseService'

import CountDown from '@/components/CountDown.vue'
import FilterDefault from '@/components/filter/FilterDefault.vue'

export default {
  components: { CountDown, ConfirmDialog, FilterDefault },
  setup() {
    const route = useRoute()
    return {
      route: route,
    }
  },
  data() {
    return {
      config: config,
      format: format,
      moment: moment,
      selectedCampanha: {},
      table: 'CAM_CAMPANHA',
      labelHeader: 'Campanhas',
      widthFilter: '450px',
      key: 0,
      key_countDown: 0,
      error: false,
      show_overlay: false,
      list: [],
      item: {},
      farmaciaID: this.$store.getters['user'].id,
      uf: this.$store.getters['user'].uf,
      statusCampanha: {
        'EM PREPARAÇÃO': 1,
        'NÃO INICIADA': 2,
        ATIVA: 3,
        SUSPENSA: 4,
        ENCERRADA: 5,
        CANCELADA: 6,
      },
      ufs: {
        ACRE: 'AC',
        ALAGOAS: 'AL',
        AMAPÁ: 'AP',
        AMAZONAS: 'AM',
        BAHIA: 'BA',
        CEARÁ: 'CE',
        'DISTRITO FEDERAL': 'DF',
        'ESPÍRITO SANTO': 'ES',
        GOIÁS: 'GO',
        MARANHÃO: 'MA',
        'MATO GROSSO': 'MT',
        'MATO GROSSO DO SUL': 'MS',
        'MINAS GERAIS': 'MG',
        PARÁ: 'PA',
        PARAÍBA: 'PB',
        PARANÁ: 'PR',
        PERNAMBUCO: 'PE',
        PIAUÍ: 'PI',
        'RIO DE JANEIRO': 'RJ',
        'RIO GRANDE DO NORTE': 'RN',
        'RIO GRANDE DO SUL': 'RS',
        RONDÔNIA: 'RO',
        RORAIMA: 'RR',
        'SANTA CATARINA': 'SC',
        'SÃO PAULO': 'SP',
        SERGIPE: 'SE',
        TOCANTINS: 'TO',
      },
      fieldsFilter: [
        {
          label: 'Nome',
          slug: 'nome',
          endpoint: 'default/CAM_CAMPANHA/search/params?',
          value: '',
          type: 'text',
          required: false,
          class: 'col-md-12 col-sm-12 col-lg-12',
        },
        {
          label: 'Identificação da Campanha',
          slug: 'identificacao',
          endpoint: 'default/CAM_CAMPANHA/search/params?',
          value: '',
          type: 'text',
          required: false,
          class: 'col-md-12 col-sm-12 col-lg-12',
        },
        {
          label: 'Estado',
          slug: 'in_uf',
          optionsCombo: [],
          inputCombo: [],
          type: 'multiselect',
          required: true,
          class: 'col-md-12 col-sm-12 col-lg-12',
        },
        {
          label: 'Status Campanha',
          slug: 'in_cam_campanha_status_id',
          optionsCombo: [
            'EM PREPARAÇÃO',
            'NÃO INICIADA',
            'ATIVA',
            'SUSPENSA',
            'ENCERRADA',
            'CANCELADA',
          ],
          value: ['ATIVA', 'EM PREPARAÇÃO'],
          type: 'multiselect',
          required: false,
          class: 'col-md-12 col-sm-12 col-lg-12',
        },
        {
          label: 'Início',
          slug: 'data_ini',
          endpoint: 'default/CAM_CAMPANHA/search/params?',
          value: startOfMonth(new Date()),
          type: 'date',
          required: false,
          class: 'col-md-12 col-sm-12 col-lg-12',
        },
        {
          label: 'Fim',
          slug: 'data_fim',
          endpoint: 'default/CAM_CAMPANHA/search/params?',
          value: endOfMonth(new Date()),
          type: 'date',
          required: false,
          class: 'col-md-12 col-sm-12 col-lg-12',
        },
      ],
      filter: {},
      admin: localStorage.getItem('admin') === 'true',
      pedidosNaoEnviados: {},
      interval_id: 0,
    }
  },
  async created() {
    if (this.admin) {
      await this.getListCampanhasAdmin()
      await this.validaDatas(this.list)
      await this.getListCampanhasAdmin()
      await this.getPedidosNaoEnviados()

      this.fieldsFilter[2].optionsCombo = Object.keys(this.ufs)
    } else {
      await this.getListCampanhas()
    }
  },
  mounted() {
    if (this.admin) {
      this.interval_id = window.setInterval(async () => {
        await this.getPedidosNaoEnviados()
      }, 600000)

      this.socket = new WebSocket('ws://localhost:8443')
      this.socket.onmessage = async (event) => {
        await this.getPedidosNaoEnviados()
        const data = JSON.parse(event.data)
        alert(
          `Um novo pedido foi realizado pela empresa ${data.enterprise.nomereduzido} para a campanha ${data.campain.nome}`,
        )
      }
    }

    this.emitter.on('modal-filter', (event) => {
      this.$refs.filtroCampanha.toggle(event)
    })
    this.emitter.on('update-filter', (event) => {
      this.filter = event[1]

      const rota = this.$route.path
      var filtros = this.$store.getters['filtros'].value
      filtros[rota] = this.fieldsFilter

      this.$store.commit({
        type: 'setFiltros',
        value: filtros,
      })

      //this.$refs.filtroCampanha.toggle(event[0])
      this.$refs.filtroCampanha.hide()
      this.getListCampanhasAdmin()
    })
  },
  beforeUnmount() {
    window.clearInterval(this.interval_id)
    this.emitter.off('modal-filter')
    this.emitter.off('update-filter')
  },
  methods: {
    associarFarmacias(campanha) {
      this.$router.push({
        path: `/associar-farmacias/${campanha.id}`,
        name: 'Associar Farmácias',
        params: {
          campanha_id: campanha.id,
        },
      })
    },
    rowClass(item) {
      if (item.prioridade == 0) {
        return 'campanha-prioritaria'
      } else if (item.envio_automatico == 1) {
        return 'envio-automatico'
      } else {
        return null
      }
    },
    setupFilter() {
      const rota = this.$route.path

      var filtros = this.$store.getters['filtros'].value
        ? this.$store.getters['filtros'].value
        : {}

      if (filtros[rota] === undefined) {
        filtros[rota] = this.fieldsFilter
        this.$store.commit({
          type: 'setFiltros',
          value: filtros,
        })
      } else {
        this.fieldsFilter = filtros[rota]
      }

      this.fieldsFilter.forEach((field) => {
        this.filter[field.slug] = field.value
      })
    },
    async getPedidosNaoEnviados() {
      const list = await this.getListCampanhasPedidosNaoEnviados()
      try {
        for (let i = 0; i < list.length; i++) {
          const campanha = list[i]
          var http = new service(
            `default/CAM_PEDIDO/search/params?cam_campanha_id=${campanha.id}&pedido_enviado=N&situacao=P&join=[{'table':'CAM_CAMPANHA','input':'ID','return':'NOME'}]`,
          )
          await http.find().then(async (resp) => {
            if (resp.data.response.length > 0) {
              this.pedidosNaoEnviados[resp.data.response[0].cam_campanha_id] = {
                nome_campanha: resp.data.response[0].cam_campanha_nome,
                qtd_pedidos: resp.data.response.length,
              }
            }
          })
        }

        this.$store.commit({
          type: 'setPedidosNaoEnviados',
          value: this.pedidosNaoEnviados,
        })
      } catch (error) {
        this.$toast.warning(
          'Ocorreu um erro ao buscar os pedidos não enviados!',
        )
      }
    },
    async getListCampanhasPedidosNaoEnviados() {
      let response = []
      try {
        const status_ids = [3, 5].join()

        this.show_overlay = true
        var http = new service(
          `CAM_CAMPANHA/search/params?&limit=99999&in_cam_campanha_status_id=${status_ids}`,
        )
        await http
          .find()
          .then(async (resp) => {
            response = resp.data.response
            this.show_overlay = false
            this.key++
          })
          .catch(() => {
            this.show_overlay = false
            this.key++
          })
      } catch (error) {
        this.$toast.warning(
          'Ocorreu um erro ao buscar os pedidos não enviados!',
        )
      }

      return response
    },
    async getListCampanhasAdmin() {
      this.setupFilter()

      var ids = []
      if (this.filter.in_cam_campanha_status_id) {
        ids = this.filter.in_cam_campanha_status_id.map(
          (status) => this.statusCampanha[status],
        )
      } else {
        // Se nenhum status for selecionado, traz todas as campanhas
        ids = [1, 2, 3, 4, 5, 6]
      }

      var ufs = []
      if (this.filter.in_uf) {
        ufs = this.filter.in_uf.map((uf) => this.ufs[uf])
      } else {
        ufs = []
      }

      ids.join()
      delete this.filter.cam_campanha_status_id
      this.filter.in_cam_campanha_status_id = ids

      ufs.join()
      delete this.filter.uf
      this.filter.in_uf = ufs

      var query = qs.stringify(this.filter)

      this.show_overlay = true
      var http = new service(`CAM_CAMPANHA/search/params?&limit=99999&${query}`)
      await http
        .find()
        .then(async (resp) => {
          this.list = resp.data.response
          this.show_overlay = false
          this.key++
        })
        .catch(() => {
          this.show_overlay = false
          this.key++
        })

      this.list?.forEach(async (campanha) => {
        campanha.status = campanha.cam_campanha_status_descricao
      })
      this.list?.sort((a, b) => {
        return new Date(a.data_fim) - new Date(b.data_fim)
      })
    },
    newItem() {
      this.item = {}
      this.$router.push('/campanha')
    },
    updateItem(item) {
      this.item = item
      this.$router.push(`/campanha/${item.id}`)
    },
    async deleteItem(item) {
      this.$confirm.require({
        message: 'Deseja prosseguir com a deleção?',
        header: 'Confirmação de deleção!',
        icon: 'pi pi-info-circle',
        acceptClass: 'p-button-danger',
        accept: async () => {
          var http = new service(`default/${this.table}`)
          await http.delete(item.id).then(() => {
            let i = this.list.map((item) => item.id).indexOf(item.id)
            this.list.splice(i, 1)
            this.$toast.success('Item Excluído com Sucesso!')
          })
        },
      })
    },
    abreListaPedidos(campanha) {
      this.$router.push({
        params: { id: campanha.id },
        path: `/pedidos/${campanha.id}`,
        name: 'Lista Pedidos Campanha',
      })
    },
    exibeHistoricoPedidos() {
      const farmacia_matriz_id = this.$store.getters['user'].id
      this.$router.push({
        path: `/historico-pedidos/${farmacia_matriz_id}`,
        name: 'Historico de Pedidos',
        params: {
          farmacia_matriz_id: farmacia_matriz_id,
        },
      })
    },
    abreListagemFarmacias(campanha) {
      this.$router.push({
        path: `/pedido-farmacias/${campanha.id}/${this.farmaciaID}`,
        params: {
          id: campanha.id,
          farmacia_matriz_id: this.farmaciaID,
        },
      })
    },
    async getCampanhasNaoIniciadas() {
      try {
        const hoje = moment(new Date())

        const CAMP_NAO_INICIADA = 2
        const CAMP_ATIVA = 3
        this.show_overlay = true
        var http = new service(
          `CAM_CAMPANHA/search/params?cam_campanha_status_id=${CAMP_NAO_INICIADA}`,
        )
        await http
          .find()
          .then(async (resp) => {
            resp.data.response.forEach(async (campanha) => {
              var dataIni = moment(campanha.data_ini, 'YYYY-MM-DD H:mm')
              if (hoje.diff(dataIni, 'seconds') > 0) {
                var http = new service(`default/CAM_CAMPANHA`)
                await http.update(campanha.id, {
                  cam_campanha_status_id: CAMP_ATIVA,
                })
              }
            })

            this.show_overlay = false
            this.key++
          })
          .catch(() => {
            this.error = true
            this.show_overlay = false
            this.key++
          })
      } catch {
        this.error = true
        this.show_overlay = false
        this.key++
      }
    },
    async selectCampainsToShow() {
      for (let i = 0; i < this.list.length; i++) {
        const campanha = this.list[i]
        if (campanha.selfarma == 'S') {
          const http = new service(
            `default/CAM_CAMPANHA_LOJA/search/params?&farmacia_id=${this.farmaciaID}&cam_campanha_id=${campanha.id}`,
          )
          await http.find().then((resp) => {
            if (resp.data.response.length == 0) {
              this.list[i].excluir = true
            }
          })
        }
      }

      this.list = this.list.filter((campanha) => !campanha.excluir)
    },
    async getListCampanhas() {
      await this.getCampanhasNaoIniciadas()
      const CAMP_ATIVA_ID = 3
      this.show_overlay = true
      var http = new service(
        `CAM_CAMPANHA/search/params?cam_campanha_status_id=${CAMP_ATIVA_ID}&uf=${this.uf}`,
      )
      await http
        .find()
        .then(async (resp) => {
          this.list = resp.data.response
          await this.selectCampainsToShow()
          this.show_overlay = false
          this.key++
        })
        .catch(() => {
          this.error = true
          this.show_overlay = false
          this.key++
        })

      this.list?.forEach(async (campanha) => {
        campanha.status = campanha.cam_campanha_status_descricao
      })
      this.list?.sort((a, b) => {
        return new Date(a.data_fim) - new Date(b.data_fim)
      })
    },
    async finalizaCampanha() {
      this.validaDatas(this.list)
      if (this.admin) {
        this.getListCampanhasAdmin()
      } else {
        this.getListCampanhas()
      }
    },
    async validaDatas(campanhas) {
      // Valida a data de início e fim da campanha e corrige o status da campanha de acordo com a data atual e as respectivas
      // datas de início e fim da campanha

      const hoje = moment(new Date())
      const STATUS_NAO_INICIADO = 2
      const STATUS_ATIVO = 3
      //const STATUS_SUSPENSO = 4
      const STATUS_ENCERRADO = 5
      const STATUS_CANCELADO = 6
      campanhas.forEach(async (campanha) => {
        var http = new service(`default/CAM_CAMPANHA`)
        var dataIni = moment(campanha.data_ini, 'YYYY-MM-DD H:mm')
        var dataFim = moment(campanha.data_fim, 'YYYY-MM-DD H:mm')
        var status_atualizado_campanha = null

        if (
          hoje.diff(dataFim, 'seconds') > 0 &&
          campanha.cam_campanha_status_id !== STATUS_ENCERRADO &&
          campanha.cam_campanha_status_id !== STATUS_CANCELADO
        ) {
          status_atualizado_campanha = STATUS_ENCERRADO // ENCERRADA

          const obj = {
            cam_campanha_status_id: status_atualizado_campanha,
          }
          await http.update(campanha.id, obj)
        } else if (
          hoje.diff(dataIni, 'seconds') > 0 &&
          campanha.cam_campanha_status_id == STATUS_NAO_INICIADO
        ) {
          status_atualizado_campanha = STATUS_ATIVO

          const obj = {
            cam_campanha_status_id: status_atualizado_campanha,
          }
          await http.update(campanha.id, obj)
        }
      })
    },
    async abreFormPedido(campanha) {
      const farmaciaUsuario = await this.getFarmaciaUsuario()
      const pedidoUsuario = await this.getPedidoFarmacia(
        campanha,
        farmaciaUsuario,
      )

      this.$store.commit({
        type: 'setHiperfarmaPedidoUsuario',
        value: {
          ...pedidoUsuario,
          valor_minimo: campanha.valor_minimo,
          obs: campanha.obs,
          preco_final_st: campanha.preco_final_st,
        },
      })

      await this.$router.push({
        path: '/pedido-usuario-hiperfarma',
        name: 'Pedido Usuário Hiperfarma',
      })
    },
    async getPedidoFarmacia(campanha, farmacia) {
      var pedido = {}
      var http = new service(
        `default/CAM_PEDIDO/search/params?cam_campanha_id=${campanha.id}&farmacia_id=${farmacia.id}`,
      )
      await http.find().then((res) => {
        pedido = res.data.response[0]
      })

      if (!pedido) {
        pedido = {
          cam_campanha_id: campanha.id,
          farmacia_id: farmacia.id,
        }
      }

      return pedido
    },
    async getFarmaciaUsuario() {
      var farmacia = {}
      const http = new service(
        `default/FIN_CLIENTE/search/params?id=${this.farmaciaID}`,
      )
      await http
        .find()
        .then((resp) => {
          farmacia = resp.data.response[0]
        })
        .catch((error) => {
          console.log(error)
        })

      return farmacia
    },
    async getCNPJS() {
      this.show_overlay = true
      var farmaciaMatriz = {}
      const httpFarmacia = new service(
        `default/FIN_CLIENTE/search/params?id=${this.farmaciaID}`,
      )
      await httpFarmacia.find().then((resp) => {
        farmaciaMatriz = resp.data.response[0]
      })

      var cnpjs = []
      if (farmaciaMatriz) {
        var http = new service(
          `default/FIN_CLIENTE/search/params?&email=${
            farmaciaMatriz.email
          }&${localStorage.getItem('var_source')}&limit=999&diff_classe=03`,
        )
        await http.find().then((resp) => {
          cnpjs = resp.data.response.map((item) => {
            return item.cnpjcpf
          })
        })
      } else {
        this.$toast.warning(
          'Ocorreu um erro ao buscar os CNPJs das farmácias filiais!',
        )
      }

      this.show_overlay = false

      return cnpjs
    },
    async downloadProdutos(item) {
      const cnpjs = await this.getCNPJS()
      var listaProdutos = []
      var http = new service(
        `default/CAM_CAMPANHA_PRODUTO/search/params?cam_campanha_id=${item.id}&limit=999&sort=descricao`,
      )
      await http.find().then((resp) => {
        // precisa mapear cada cpnj para cada produto
        listaProdutos = resp.data.response.map((produto) => {
          return cnpjs.map((cnpj) => {
            return {
              cnpj: cnpj,
              cean: produto.cean,
              descricao: produto.descricao,
              valor_unitario: produto.valor_unitario,
            }
          })
        })

        listaProdutos = [].concat.apply([], listaProdutos)
        listaProdutos.sort((a, b) => {
          return a.cnpj - b.cnpj
        })
      })
      const fileName = `exportacao_Big_Linx_${item.id}.xlsx`
      const listExport = listaProdutos.map((item) => {
        // Layout do arquivo de acordo com o solicitado via email
        return {
          CNPJ: item.cnpj ? item.cnpj : '',
          LOJA: '',
          COD_PRODUTO: '',
          EAN: item.cean,
          'DESCRIÇÃO PRODUTO': item.descricao,
          QUANTIDADE: '',
          PREÇO: parseFloat(item.valor_unitario),
          DESCONTO: '',
          'LABORATÓRIO/INDÚSTRIA': '',
        }
      })
      const ws = utils.json_to_sheet(listExport)
      const wb = utils.book_new()
      utils.book_append_sheet(wb, ws, 'Data')
      writeFileXLSX(wb, fileName)
    },
  },
  watch: {
    /* selectedCampanha() {
      this.key++
    }, */
    fieldsFilter: {
      deep: true,
      handler: function (val) {
        this.form = val

        if (val[0].value && val[1].value) {
          const dataIni = moment(val[0].value, ['DD/MM/YYYY HH:mm'])
          const dataFim = moment(val[1].value, ['DD/MM/YYYY HH:mm'])
          const diff = dataFim.diff(dataIni, 'minutes')
          if (diff < 0) {
            this.$toast.warning(
              'Data final não pode ser menor que data inicial!',
            )
            this.fieldsInput[1].value = val[0].value
          }
        }
      },
    },
  },
}
</script>
<style scopped>
p-row-toggler p-link {
  padding: 0rem 2rem;
}

.error-banner {
  background-color: #f8d7da;
  color: #721c24;
  padding: 0.75rem 1.25rem;
  border-color: #f5c6cb;
}

.campanha-prioritaria {
  background-color: tomato !important;
  color: #ffffff !important;
}

.envio-automatico {
  background-color: #f9e76d !important;
}

.destaque {
  color: #f9e76d !important;
  font-weight: bolder !important;
}
.icon-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  color: #333333;
  background: #28a745;
  border: none;
  outline: none;
  border-radius: 50%;
}
.icon-button:hover {
  cursor: pointer;
}
.icon-button:active {
  background: #cccccc;
}
.icon-button__badge {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 20px;
  height: 20px;
  background: red;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
</style>
